// extracted by mini-css-extract-plugin
module.exports =  {"suggested":"g7AbXHx","tag":"bnu9K4F","error":"j_lC79Q","input":"dvXCdpk","layout":"D9lIBLI","link":"MhSZ29i"};